import React from 'react';
import { Checkbox } from '../../subkit-ui';
import Link from 'next/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var AcceptTerms = function AcceptTerms(_ref) {
  var _providerService$prov, _providerService$prov2;

  var handleAcceptServiceTerms = _ref.handleAcceptServiceTerms,
      handleReceiveServiceEmails = _ref.handleReceiveServiceEmails,
      userAgreedToSubkitTerms = _ref.userAgreedToSubkitTerms,
      acceptServiceTerms = _ref.acceptServiceTerms,
      receiveServiceEmails = _ref.receiveServiceEmails,
      providerService = _ref.providerService,
      isFree = _ref.isFree,
      isSubscription = _ref.isSubscription;

  if (!(providerService !== null && providerService !== void 0 && (_providerService$prov = providerService.provider) !== null && _providerService$prov !== void 0 && _providerService$prov.name)) {
    return /*#__PURE__*/_jsx("div", {});
  }

  var serviceName = providerService === null || providerService === void 0 ? void 0 : providerService.name;
  var providerName = providerService === null || providerService === void 0 ? void 0 : providerService.provider.name;
  var providerSlug = providerService === null || providerService === void 0 ? void 0 : (_providerService$prov2 = providerService.provider) === null || _providerService$prov2 === void 0 ? void 0 : _providerService$prov2.slug;

  var renderTermsOfServiceLink = function renderTermsOfServiceLink(link) {
    return /*#__PURE__*/_jsx(Link, {
      href: link,
      children: /*#__PURE__*/_jsxs("a", {
        className: "text-subkit-primary font-medium",
        target: "_blank",
        children: ["Terms of Service", ' ']
      })
    });
  };

  var renderPrivacyPolicyLink = function renderPrivacyPolicyLink(link) {
    return /*#__PURE__*/_jsxs("a", {
      className: "text-subkit-primary font-medium",
      rel: "noreferrer",
      target: "_blank",
      href: link,
      children: ["Privacy Policy", ' ']
    });
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "mt-6 mb-12",
    children: [/*#__PURE__*/_jsx("div", {
      className: "mb-3 flex",
      children: /*#__PURE__*/_jsx("div", {
        className: "mt-0.5 text-gray-500 text-base",
        children: /*#__PURE__*/_jsx(Checkbox, {
          onChange: handleAcceptServiceTerms,
          checked: acceptServiceTerms,
          dataCy: "acceptServiceTerms",
          name: "acceptServiceTerms",
          children: /*#__PURE__*/_jsxs("span", {
            className: "text-gray-500 text-base",
            children: [isFree ? 'I agree to the ' : 'I agree to make this payment and to the ', renderTermsOfServiceLink("/".concat(providerSlug, "/terms")), " and", ' ', renderPrivacyPolicyLink("/".concat(providerSlug, "/privacy")), "from ", serviceName, " by ", providerName, !isFree && /*#__PURE__*/_jsx("span", {
              children: " that includes the auto-renewal, refund and cancellation policy "
            }), userAgreedToSubkitTerms ? '.' : ', ', !userAgreedToSubkitTerms && /*#__PURE__*/_jsxs(_Fragment, {
              children: ["as well as to Subkit's ", renderTermsOfServiceLink('/terms'), " and", ' ', renderPrivacyPolicyLink('/privacy'), "."]
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-3 flex",
      children: /*#__PURE__*/_jsx("div", {
        className: "mt-0.5",
        children: /*#__PURE__*/_jsx(Checkbox, {
          onChange: handleReceiveServiceEmails,
          checked: receiveServiceEmails,
          dataCy: "receiveServiceEmails",
          name: "receiveServiceEmails",
          children: /*#__PURE__*/_jsxs("span", {
            className: "c-gray-5 text-base",
            children: ["I agree to receive emails related to this service from ", /*#__PURE__*/_jsx("span", {
              children: serviceName
            }), " by", ' ', /*#__PURE__*/_jsx("span", {
              children: providerName
            }), " ", isSubscription ? "" : "(Recommended)", "."]
          })
        })
      })
    })]
  });
};